import { QuestionApiModel } from '../models/questions';
import { Ticket } from '../models/tickets';

/**
 * Currently if there is tax on the event, all tickets will have the same eventTaxName regardless of whether
 * tax is applied to that ticket or not.
 *
 * We may have different taxes and tax names per ticket in the future.
 *
 * @param tickets the flattened list of Tickets.
 */
export const getEventTaxName = (tickets: Array<Ticket>) => {
    return tickets.find((ticket) => !!ticket.eventTaxName)?.eventTaxName as
        | string
        | undefined;
};

export const getRequiredQuestions = (questions: QuestionApiModel[] = []) =>
    questions?.filter((question) => question.required);

export const excludeQuestionFromList =
    (questionsToExclude: string[]) => (question: QuestionApiModel) =>
        !questionsToExclude.includes(question.id);
